import script from "./InLogArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./InLogArea.vue?vue&type=script&lang=ts&setup=true"

import "./InLogArea.vue?vue&type=style&index=0&id=c216133c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c216133c"]])

export default __exports__